import { GetSignatureResponse } from "../entities/user/GetSignatureResponse";
import { RoleGetResponse } from "../pages/roles/entities/RoleGetResponse";
import { RoleListGetResponse } from "../pages/roles/entities/RoleListGetResponse";
import { RoleEditModel } from "../pages/roles/RoleEdit";

import CompanyService from "./CompanyService";
import RequestService from "./RequestService";

export enum UserRole {
  Admin = 0,
  Guest = 1,
  QueriesOnly = 2
}

export class RoleGetListRequest {
  page: number = 0;
  text: string | null = null;
  pagesize: number = 20;
}

class RoleService {
  public static height = 0;
  public static setHeight(_height: number) {
    this.height = _height;
  }

  public static getHeight() {
    return this.height;
  }

  public static getUserName(userId: number): string | undefined {
    return CompanyService.getUsers()?.find((x) => x.Id === userId.toString())
      ?.Value;
  }

  public static async get(
    roleId: string
  ): Promise<RoleGetResponse | undefined> {
    const result: RoleGetResponse | Error = await RequestService.post(
      "/role/get",
      { id: roleId }
    );
    if (result instanceof Error) {
      return undefined;
    }
    return result;
  }
  public static getList(
    request: RoleGetListRequest
  ): Promise<RoleListGetResponse | Error> {
    return RequestService.post("/role/list", request);
  }
  public static set(
    rol: RoleEditModel
  ): Promise<{ response: string; Id: number } | Error> {
    const request = { ...rol };
    return RequestService.post("/role/set", request);
  }
  public static delete(
    userId: number
  ): Promise<{ response: string; Id: number } | Error> {
    return RequestService.post("/role/delete", { id: userId });
  }

  public static reinvite(
    email: string
  ): Promise<{ response: string; Id: number } | Error> {
    return RequestService.post("/user/reinvite", { email });
  }

  public static getRole(user: {
    CompanyUserID?: number | null | undefined;
    UserID?: number | null | undefined;
    Admin: boolean;
    ReadOnly?: boolean;
  }): string {
    if (user.CompanyUserID === user.UserID) {
      return "Creator";
    }
    if (user.Admin) {
      return "Administrator";
    }
    if (user.ReadOnly) {
      return "Readonly";
    }
    return "Guest";
  }

  public static getSignatures(): Promise<GetSignatureResponse[] | Error> {
    return RequestService.post("/user/getsignatures", {});
  }
}

export default RoleService;
